var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"fill-height":""}},[_c('v-list',{staticStyle:{"max-width":"100%"}},[_vm._l((_vm.list),function(onboarding){return _c('OnboardingItem',{key:onboarding.id,attrs:{"admin":"","onboarding":onboarding}})}),_c('CreateOnboarding',{staticStyle:{"position":"sticky","bottom":"5px","right":"5px"}})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }